"use client";

import { AuthFlowHeader } from "../../auth-flow-header";
import React, { useState } from "react";
import { Button, Input, Label } from "@/components/ui";
import { PhoneAuthStep, usePhoneAuth } from "./phone-auth-context";
type NameCompletionProps = {
  className?: string;
};
export function NameCompletion({
  className
}: NameCompletionProps) {
  const {
    state,
    actions
  } = usePhoneAuth();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (state.step !== PhoneAuthStep.NAME) return null;
  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await actions.completeName(firstName, lastName);
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className={className}>
      <div className="space-y-2 text-center">
        <AuthFlowHeader title="We've noticed that you're a new patient!" description="Please enter your legal first and last name to proceed." />
      </div>

      <form onSubmit={onSubmit} className="space-y-4 text-left">
        <div className="space-y-1">
          <Label htmlFor="firstName" mandatory>
            First Name
          </Label>
          <Input id="firstName" placeholder="First Name" value={firstName} onChange={e_0 => setFirstName(e_0.target.value)} />
        </div>

        <div className="space-y-1">
          <Label htmlFor="lastName" mandatory>
            Last Name
          </Label>
          <Input id="lastName" placeholder="Last Name" value={lastName} onChange={e_1 => setLastName(e_1.target.value)} />
        </div>

        <Button type="submit" className="w-full" variant="primary" isLoading={isSubmitting} disabled={isSubmitting}>
          Continue
        </Button>
      </form>
    </div>;
}